<template>
  <h3 :class="headingClass">
    <span class="subtitle" v-if="!!subtitle">{{ subtitle }}</span>
    <span class="title">{{ title }}</span>
    <!--
    <div class="seelater" v-if="showSeelater">
      <icon-base name="SeeLaterIcon" color="#FF7497" width="15" height="15" :is-button="false" />
      <span class="num">{{ seelaterNum }}</span>
    </div>
    -->
    <see-later-button
      v-if="showSeelater"
      :user-id="userId"
      :tag-id="`${itemData.id}`"
      :seelater-num="itemData.seelater_num"
      :is-seelater="itemData.is_seelater"
      :in-list-item="true"
    />
  </h3>
</template>

<script>
import { SEC_ICON_TYPE } from '@/CONSTS/MENUS.js'
import IconBase from '@/utvStore/components/common/icon/IconBase.vue'
import SeeLaterButton from '@/utvStore/components/partials/SeeLaterButton'

export default {
  name: "ItemHeading",
  components:{
    //IconBase
    SeeLaterButton
  },
  data() {
    return {
      iconColor: '#FF7497',
      iconBgColor: 'white'
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    /*
    showSeelater: {
      type: Boolean,
      default: false
    },
     */
    seelaterNum: {
      type: Number,
      default: 0
    },
    isCategory: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number,
      default: -1
    },
    itemData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    headingClass(){
      let classArr = []
      if( this.subtitle != null && this.subtitle.length > 0 ) classArr.push('has-subtitle')
      if( this.isSmall ) classArr.push('small')
      return classArr.join(' ')
    },
    showSeelater(){
      //!isCategory && itemData.id !== 'history'

      return this.isCategory
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

h3 {
  font-weight: bold;
  font-size: 17px;
  position: relative;
  margin: 0 0 4px;
  &.small {
    font-size: 14px;
  }
  &.has-subtitle {
    padding-top: 40px;
    background-position: right 16px top 38px;
    .icon {
      top: 40px;
    }
  }
  .subtitle {
    display: inline-block;
    font-weight: bold;
    font-size: 11px;
    line-height: 1;
    position: absolute;
    color: $col_lite_font;
    top: 24px;
  }
  .title {
    display: block;
  }
  .seelater{
    display: inline-flex;
    align-items: center;
    margin-top: 7px;
    .num{
      font-size: 11px;
      color: $col_temp_gray6;
      margin-left: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/ItemHeading.vue